/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/* Utils */
import {
  getFirstGenre,
  useFullEpisodeName,
  isEpisode,
  isMovie,
  isShow,
  joinArrayWithSeparator,
  joinArrayWithSpace,
  getRating,
} from '../../utils/metaDataUtils';

export function useSubtitleMyList(vodContent) {
  const { formatMessage } = useIntl();
  const fullEpisodeName = useFullEpisodeName(vodContent);
  return useMemo(() => joinArrayWithSeparator([
    isShow(vodContent) && formatMessage({ id: 'common.serie' }),
    vodContent?.rating,
    isEpisode(vodContent) && fullEpisodeName,
    isMovie(vodContent) && getFirstGenre(vodContent),
    isMovie(vodContent) && vodContent?.releaseYear,
  ]), [formatMessage, fullEpisodeName, vodContent]);
}

export function useSubtitleVod(vodContent) {
  const { formatMessage } = useIntl();
  const fullEpisodeName = useFullEpisodeName(vodContent, false, ', ');

  return useMemo(() => joinArrayWithSpace([
    getRating(vodContent),
    joinArrayWithSeparator([
      isShow(vodContent) && formatMessage({ id: 'common.serie' }),
      isEpisode(vodContent) && fullEpisodeName,
      isMovie(vodContent) && vodContent?.releaseYear,
    ], ', '),
  ]), [formatMessage, fullEpisodeName, vodContent]);
}
